import { type GalleryGroupType } from '@/defs/gallery'
import { type RecType } from '@/defs/rec'
import { slugify } from '@/utils/commonUtil'
import { buildRec } from '@/utils/recUtil'

import { getGalleryResults } from './getGalleryResults'
import { parseGalleryCategory } from './parseGalleryCategory'

const REGEX_CATEGORY = /\[([A-zÀ-ž-\s\d']+)\]/g
const REGEX_CARDLINE = /\*?(\d+)\s+([A-zÀ-ž\s'-/|\d:"&]+)/

export const parseGalleryDeck = (rawDeck: string = '') => {
  const categoryLines = rawDeck.match(REGEX_CATEGORY)
  const deckLines = rawDeck.split('\n')

  const recs: RecType[] = []
  const categories: Omit<GalleryGroupType, 'recs'>[] = []

  let latestCategory = ''
  deckLines.forEach((raw) => {
    const line = raw.trim()
    if (categoryLines?.includes(line)) {
      latestCategory = line.replace('[', '').replace(']', '')
      categories.push(parseGalleryCategory(latestCategory))
      return
    }

    if (line.length <= 3) return

    if (line.slice(0, 2) !== '[/') {
      const cardParts = REGEX_CARDLINE.exec(line)
      const name = (cardParts ? cardParts[2] : line) || ''
      recs.push(
        buildRec({
          category: slugify(latestCategory),
          count: cardParts?.[1] ? parseInt(cardParts[1]) : 1,
          name,
        }),
      )

      return
    }
  })

  const { groups } = getGalleryResults({
    cardMap: {},
    categories,
    groupby: 'category',
    priceSource: 'cardkingdom',
    recs,
    sortby: 'name',
    sortbyDirection: 'desc',
  })

  return groups
}
